import AssessmentSwitch from './AssessmentSwitch';

export default AssessmentSwitch;
